import React, { useState, useEffect } from "react";
import { Text, Switch, Table, NumberInput, Grid, Tabs } from "@mantine/core";
import _ from "lodash";
import { FormSectionCard } from "../layout/page";
import { useServerApi } from "../hooks/userServerApi";
import { showNotification } from "@mantine/notifications";
import { Group } from "@mantine/core";
// import ReactJson from "react-json-view";

import OverridingTable from "./overridingTable";

const CommissionSplitSection = ({ mainForm }) => {
  return (
    <FormSectionCard title="Split" mt="50px">
      <Grid>
        {mainForm?.values?.commissionSetting?.split?.map((item, index) => (
          <Grid.Col key={index} span={12}>
            <Grid align="center">
              <Grid.Col span={1}>
                <Text size="xs">{item.name}</Text>
              </Grid.Col>
              <Grid.Col span={2}>
                <NumberInput
                  value={item.value}
                  onChange={(value) => {
                    const newSplit = [
                      ...mainForm.values.commissionSetting.split,
                    ];
                    newSplit[index].value = value;
                    mainForm.setFieldValue("commissionSetting.split", newSplit);
                  }}
                  min={0}
                  max={100}
                  precision={2}
                  rightSection={<Text size="sm">%</Text>}
                  styles={{ rightSection: { width: 30 } }}
                  size="xs"
                />
              </Grid.Col>
            </Grid>
          </Grid.Col>
        ))}
      </Grid>
    </FormSectionCard>
  );
};

const OverridingPlanForm = ({ mainForm, index }) => {
  return (
    <FormSectionCard>
      <Group grow mb="30px" gap="xl">
        <div>
          <NumberInput
            size="xs"
            label="Money Round Digit"
            required
            min={0}
            max={5}
            {...mainForm.getInputProps(
              `commissionSetting.overridingPlans.${index}.moneyRoundDigit`
            )}
          />

          <NumberInput
            size="xs"
            label="Rate Round Digit (%)"
            required
            min={0}
            max={5}
            {...mainForm.getInputProps(
              `commissionSetting.overridingPlans.${index}.rateRoundDigit`
            )}
          />
        </div>

        <div>
          <Switch
            size="xs"
            label="Round On Rate"
            mb="xs"
            mt="xl"
            {...mainForm.getInputProps(
              `commissionSetting.overridingPlans.${index}.roundOnRate`,
              { type: "checkbox" }
            )}
          />

          <Switch
            size="xs"
            label="Use Internal Currency Exchange Rate"
            mb="xs"
            {...mainForm.getInputProps(
              `commissionSetting.overridingPlans.${index}.useInternalExchangeRate`,
              { type: "checkbox" }
            )}
          />

          <Switch
            size="xs"
            label="Allow Direct on Premium (Skip Product Rate)"
            mb="xs"
            {...mainForm.getInputProps(
              `commissionSetting.overridingPlans.${index}.allowSkipProviderRate`,
              { type: "checkbox" }
            )}
          />
        </div>
      </Group>
      <OverridingTable
        form={mainForm}
        name={`commissionSetting.overridingPlans.${index}.table`}
        size="xs"
      />
    </FormSectionCard>
  );
};

const CommissionSetting = ({ form: mainForm, name, readonly = false }) => {
  const dnId = mainForm?.values?._id;
  const dn = _.get(mainForm, "values");

  let isCustomize = dn.commissionSetting && dn.commissionSetting?.isCustomize;

  const [api] = useServerApi();

  const numOfProducers = mainForm?.values?.consultants?.length;

  const loadDefaultCommissionSetting = async () => {
    if (numOfProducers === 0) {
      showNotification({
        title: "No producers found",
        message: "Please add at least one producer",
        color: "red",
      });
      return;
    }

    const commissionSetting = {
      isCustomize: true,
      split: Array.from({ length: numOfProducers }, (_, index) => ({
        name: `Tree ${index + 1}`,
        value: +(100 / numOfProducers).toFixed(2),
      })),
      overridingPlans: [],
    };

    for (let i = 0; i < numOfProducers; i++) {
      const result = await api.User.getOverridingPlan(
        dn.consultants[i]._id ?? dn.consultants[i]
      );
      if (result && result.overridingPlan) {
        commissionSetting.overridingPlans.push({
          ...result.overridingPlan,
          _id: null,
        });
      }
    }
    mainForm.setFieldValue("commissionSetting", commissionSetting);
  };

  return (
    <>
      {/* <ReactJson
        src={dn.commissionSetting}
        collapsed
        style={{ background: "white" }}
      /> */}
      <Switch
        size="xs"
        label={isCustomize ? "CUSTOMIZE" : "DEFAULT"}
        checked={isCustomize}
        defaultChecked={isCustomize}
        onChange={(e) => {
          if (!e.target.checked) {
            mainForm.setFieldValue("commissionSetting", null);
          } else {
            loadDefaultCommissionSetting();
          }
        }}
      />

      {isCustomize && <CommissionSplitSection mainForm={mainForm} />}

      {/* //For each overriding plan */}
      {isCustomize && (
        <Tabs defaultValue="0">
          <Tabs.List>
            {mainForm?.values?.commissionSetting?.overridingPlans?.map(
              (_, index) => (
                <Tabs.Tab key={index} value={index.toString()}>
                  Tree {index + 1}
                </Tabs.Tab>
              )
            )}
          </Tabs.List>

          {mainForm?.values?.commissionSetting?.overridingPlans?.map(
            (op, index) => (
              <Tabs.Panel key={index} value={index.toString()}>
                <OverridingPlanForm mainForm={mainForm} index={index} />
              </Tabs.Panel>
            )
          )}
        </Tabs>
      )}
    </>
  );
};

export default CommissionSetting;
